export default "__VITE_ASSET__Cu58dVYS__"